import PropTypes from 'prop-types';
import React from 'react';
import { Table, WeezHeader, Dropdown, Button, EmptyState, Icon, Card } from '@weezevent/nacre';
import LoadingTable from '../../components/loadingTable';
import { useHistory } from 'react-router-dom';

import { Trans, useTranslation } from 'react-i18next';
import Tag from '../../models/tag';

export default function TagsList({ match, organization }) {
    const { t } = useTranslation();

    const history = useHistory();

    const organizationId = organization.id;

    const [tags, loadingTags] = Tag.useApiModel({
        organizationId
    });

    return (
        <>
            <WeezHeader
                title={<Trans i18nKey="main_menu_tags" />}
                rightComponent={<Button primary onClick={() => history.push(`/ticket/O${organizationId}/tags/new`)} label={<Trans i18nKey="ticket.common.action.add" />} />}
            />
            <Card>
                <Table>
                    <Table.Header>
                        <Table.HeaderRow>
                            <Table.HeaderCell content="#" />
                            <Table.HeaderCell>Label</Table.HeaderCell>
                        </Table.HeaderRow>
                    </Table.Header>
                    <Table.Body>
                        {tags &&
                            tags.map(tag => (
                                <Table.Row key={`row-${tag.id}`}>
                                    <Table.Cell content={tag.id} />
                                    <Table.Cell content={tag.label} />
                                    <Table.CellDropdown>
                                        <Dropdown.Item item={t(['ticket.common.action.edit'])} onClick={() => history.push(`/ticket/O${organizationId}/tags/${tag.id}`)} />
                                    </Table.CellDropdown>
                                </Table.Row>
                            ))}
                    </Table.Body>
                </Table>
                <LoadingTable loading={loadingTags} />
                {!loadingTags && tags.length === 0 && <EmptyState icon={<Icon name="list" />} title={t('ticket.tags.empty.title')} subtitle={t('ticket.tags.empty.subtitle')} />}
            </Card>
        </>
    );
}

TagsList.propTypes = {
    match: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired
};
